// wrapper that will initially only have a feature flag config
import React, { createContext } from 'react';
import { DEFAULT_APP_KIT_CONFIG } from './defaultValues';
export const AppKitContext = createContext(DEFAULT_APP_KIT_CONFIG);
export const AppKitConfig = ({ children, customFeatureConfig, }) => {
    const value = {
        featureFlagConfig: {
            ...DEFAULT_APP_KIT_CONFIG.featureFlagConfig,
            ...customFeatureConfig,
        },
    };
    return (React.createElement(AppKitContext.Provider, { value: value }, children));
};
